import styled from 'styled-components';

import { SectionTitle } from '../../../../../components/v2/Section';
import colors from '../../../../../styles/colors';

const SectionLabel = styled(SectionTitle)`
  color: ${colors.shades.gamma7};
  letter-spacing: 0.5px;
  margin-bottom: 12px;
`;

export {
  SectionLabel,
};
